/** Mutual-exclusivity for <x-faq> details groups (was inline <script> inside #app). */
export function initFaqDetailsGroups() {
    if (typeof document === 'undefined') return;
    if (window.__faqDetailsGroupsBound) return;
    if (!document.querySelector('[data-faq-group]')) return;

    window.__faqDetailsGroupsBound = true;

    document.addEventListener('toggle', function (event) {
        const target = event.target;
        if (!target || target.tagName !== 'DETAILS' || !target.open) return;

        const group = target.closest('[data-faq-group]');
        if (!group) return;

        const name = target.getAttribute('name');
        if (!name) return;

        group.querySelectorAll('details[name="' + name + '"][open]').forEach(function (other) {
            if (other !== target) other.open = false;
        });
    }, true);
}
